'use es6';

import createReactClass from 'create-react-class';
import React from 'react';
import I18n from 'I18n';
import { commonPropTypes, I18nCommonMixin, getPassThroughProps } from './utils';
export default createReactClass({
  displayName: "FormattedReactMessage",
  mixins: [I18nCommonMixin],
  propTypes: commonPropTypes,
  getEscapedParam: function getEscapedParam(param, key, index) {
    if (!React.isValidElement(key)) {
      return React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: I18n.formatParam(param, key)
        },
        key: param + "-" + index
      });
    }

    return React.cloneElement(key, {
      key: param + "-" + index,
      ref: key.ref
    });
  },
  renderFormattedMessage: function renderFormattedMessage() {
    return I18n.interpolateToArray(this.props.message, this.props.options, this.getEscapedParam);
  },
  render: function render() {
    var props = getPassThroughProps(this.props);
    return React.createElement("span", props, this.renderFormattedMessage());
  }
});